import { DirectionalHint, FontIcon, PanelType, Stack, Text, TooltipHost } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { customerStyles } from "./styles/customerStyles";
import SamplePanel from "../Panel";
import { usePanelClasses } from "../Panel/panel";
import { observer } from "@/utilities/storeHook";
import { classNames, deleteParam, getCurrentValue, getLocalStorage, getParameter, getPathName, setLocalStorage, updateURL } from "@/utilities/common";
import { customrOption } from "@BZA/Account/Customer/customerOption";
import { useNavigate } from "react-router-dom";
import { textStyles } from "@/styles/textStyles";
import { TooltipHostCalloutProps } from "../TooltipHostCalloutProps";
import PanelContent from "./customerPanel";
import eventBus from "@/utilities/eventBus";
import store from "@/store";
import { getBasePath, getDefaultRouter, isACustomerAgency, verifyProduct } from "@/utilities/function";
import { isLeadGenAgency } from "@LeadGen/utilities/function";
import styles from "./styles/currentCustomer.modules.less";

interface CalloutProps {
  gapSpace?: number,
  beakWidth?: number,
  directionalHint?: DirectionalHint,
  isBeakVisible?: boolean
}
export interface IButtonExampleProps {
  // These are set based on the toggles shown above the examples (not needed in real code)
  disabled?: boolean;
  checked?: boolean;
  menuList: any;
}

const Customer: React.FunctionComponent<IButtonExampleProps> = (props) => {
  const navigate = useNavigate();
  const pathName = getPathName();
  const routerParamsCID = Number(getParameter("cid"));
  const routerParamsAID = Number(getParameter("aid"));
  const t = getParameter("t") || 0;
  const [isCalloutVisible, setToggleIsCalloutVisible] = useState(false);
  const [MSALInfo, setMSALInfo] = useState<any>();
  const [customerInfo, setCustomerInfo] = useState<any>();
  const { search } = location;
  const { userStore } = store;

  useEffect(() => {
    if (props.menuList !== undefined) {
      setCustomerInfo(props.menuList);
    }
    setToggleIsCalloutVisible(false);
    if (routerParamsCID) {
      const currentCustomerInfo = customrOption.getCustomers()?.customers?.filter((item: any) => item?.customerId === Number(routerParamsCID))[0];
      if (currentCustomerInfo?.customerStatus === 0) {
        setLocalStorage("createdCustomer", currentCustomerInfo);
        navigate("/giveCIDAndUID");
      } else if (currentCustomerInfo?.customerStatus !== 0 && currentCustomerInfo?.numberOfAccounts === 0) {
        setLocalStorage("currentCID", currentCustomerInfo?.customerId);
        const newBasePath = getBasePath(Number(currentCustomerInfo?.productType), Number(currentCustomerInfo?.primaryPurpose), "/leadgen_createAccount", "/createAccount");
        navigate(newBasePath);
      } else {
        setCustomerInfo(currentCustomerInfo);
        setLocalStorage("currentCustomer", currentCustomerInfo);
        if (verifyProduct(Number(currentCustomerInfo?.productType), Number(currentCustomerInfo?.primaryPurpose))) {
          const newBasePath = getBasePath(Number(currentCustomerInfo?.productType), Number(currentCustomerInfo?.primaryPurpose), pathName?.slice(1), currentCustomerInfo?.region.toLowerCase() === "zh-cn" ? "dashboard" : "Non_dashboard");
          const url = getDefaultRouter(currentCustomerInfo[0]?.customerType,
            !isLeadGenAgency(currentCustomerInfo[0]?.agencyType)
              ? "waitingOrder"
              : "leadgen_accountManagement",
            `?cid=${routerParamsCID}${routerParamsAID
              ? `&aid=${routerParamsAID}`
              : ""}&t=${t}`,
            newBasePath);
          navigate(url);
        }
        if (currentCustomerInfo?.customerId === routerParamsCID) {
          return;
        }
        let updateUrl = deleteParam(search, "cid");
        if (routerParamsAID) {
          updateUrl = deleteParam(updateURL(updateUrl), "aid");
          updateUrl = updateURL(updateUrl).indexOf("?") !== -1 ? updateURL(updateUrl).substring(1) : updateURL(updateUrl);
          updateUrl = updateUrl ? "&" + updateUrl : updateUrl;
          navigate(`${pathName}?cid=${currentCustomerInfo?.customerId}&aid=${routerParamsAID}${updateUrl}`);
        } else {
          updateUrl = updateURL(updateUrl).indexOf("?") !== -1 ? updateURL(updateUrl).substring(1) : updateURL(updateUrl);
          navigate(`${pathName}?cid=${currentCustomerInfo?.customerId}${updateUrl}`);
        }
      }
    }
  }, [routerParamsCID, routerParamsAID, props.menuList]);

  const getMsalInfos = (info?: any) => {
    const currentInfo = info || JSON.parse(getLocalStorage("userInfo") || "{}");
    setMSALInfo(currentInfo);
  };

  useEffect(() => {
    getMsalInfos();
    eventBus.off("getCurrentUserInfo");
    eventBus.on("getCurrentUserInfo", ({ info }) => {
      getMsalInfos(info);
    });
    return () => {
      setMSALInfo({});
    };
  }, [userStore.isGotUserInfo]);

  const keyupEvent = (e: any) => {
    if (e.key.toLowerCase() === "enter") {
      setToggleIsCalloutVisible(!isCalloutVisible);
    }
  };
  return (
    <>
      <div
        tabIndex={0}
        className={classNames({
          [customerStyles.buttonArea]: true,
          [styles.button_area]: true
        })}
        onKeyUp={keyupEvent}
        onClick={() => setToggleIsCalloutVisible(!isCalloutVisible)}
      >
        <Stack horizontal tokens={{ childrenGap: 10 }} style={{ padding: 10 }}>
          <Stack>
            <FontIcon iconName="Contact" style={{ fontSize: 32, color: "#fff" }} />
          </Stack>
          <Stack>
            <Text block nowrap style={{
              wordWrap: "break-word"
            }} className={textStyles.headerTitleStyleWhite}>
              {MSALInfo ? MSALInfo?.accountUsername || MSALInfo?.userPrincipalName : ""}
            </Text>
            {customerInfo
              ? <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 6 }} styles={
                {
                  root: {
                    width: "auto",
                    maxWidth: 240,
                  }
                }
              }>
                <TooltipHost
                  content={getCurrentValue(customerInfo, "customerName") + (isACustomerAgency(customerInfo?.customerType) &&
                    !isLeadGenAgency(customerInfo?.agencyType)
                    ? "(结算代理)"
                    : "")}
                  calloutProps={TooltipHostCalloutProps}
                  id={"tooltip-customerName"}
                >
                  <Text block nowrap
                    style={{
                      wordWrap: "break-word",
                      maxWidth: 140,
                    }} className={textStyles.headerTitleStyleWhite}>
                    {isACustomerAgency(customerInfo?.customerType) && !isLeadGenAgency(customerInfo?.agencyType)
                      ? <Stack style={{ width: "100%" }} horizontal>
                        <Text block nowrap style={{
                          wordBreak: "break-all",
                          wordWrap: "break-word",
                          maxWidth: "60%",
                          minWidth: "20%",
                        }} className={textStyles.headerTitleStyleWhite}>
                          {customerInfo.customerName}
                        </Text>
                        <span className={textStyles.textDisabled}>(结算代理)</span>
                      </Stack>
                      : customerInfo.customerName}
                  </Text>
                </TooltipHost>
                <TooltipHost
                  content={getCurrentValue(customerInfo, "customerNumber")}
                  calloutProps={TooltipHostCalloutProps}
                  id={"tooltip-customerNumber"}
                >
                  <Text block nowrap
                    className={textStyles.headerTitleStyleWhite}
                    style={{
                      wordWrap: "break-word"
                    }}>{customerInfo.customerNumber}</Text>
                </TooltipHost>
              </Stack>
              : null}
          </Stack>
        </Stack>
      </div>
      <SamplePanel
        className={routerParamsCID ? usePanelClasses.container : usePanelClasses.isAuthenticated}
        isBlocking={!!routerParamsCID}
        isOpen={isCalloutVisible} content={<PanelContent />} type={PanelType.custom} customWidth="400px"
        contentStyle={{
          position: "absolute",
          top: 25,
          bottom: 0,
          width: "calc(100% - 48px)",
          height: "auto"
        }}
        hasCloseButton={false}
        onDismiss={(e: any) => {
          if (e.type !== "mousedown") {
            setToggleIsCalloutVisible(!isCalloutVisible);
          }
        }}
      />
    </>
  );
};

export default observer(Customer);
